export default __webpack_public_path__ + "static/media/close.88437c19.svg";